import * as React from "react";
import "./layout.scss";

export const Layout: React.FC<{ isHeroSection?: boolean }> = ({
  isHeroSection = false,
  children,
}) => {
  return (
    <div className={`layout ${!isHeroSection && "body-layout"}`}>
      {children}
    </div>
  );
};
